import { TFilterKeys } from '../../types/filters';
import { actionGenerator } from '../../utils/redux/actionGenerator';
import { EFiltersActionType, TSetTooltipTarget } from './types';

export const setTooltipTarget: (filterKey?: TFilterKeys) => TSetTooltipTarget = actionGenerator<
  EFiltersActionType.SetTooltipTarget,
  TFilterKeys
>(EFiltersActionType.SetTooltipTarget);
